var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class SF2Scheduler {
    constructor(player) {
        this.player = player;
        this.timeUpdateCallback = null;
        this.isRunning = false;
        this.playbackTimeMillis = 0;
        this._playbackStartedTs = null;
    }
    start(entries) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isRunning = true;
            this.playbackTimeMillis = 0;
            this._playbackStartedTs = performance.now();
            yield this.player.prepareAsync();
            yield this.player.uploadSong(entries);
            this.player.start();
        });
    }
    stop() {
        this.player.stop();
    }
    scheduleNow(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.player.prepareAsync();
            this.player.output(data);
        });
    }
}
export class SF2Player {
    constructor() {
        this.worker = null;
        this.ready = false;
        this.audioCtx = null;
    }
    init(sampleRate) {
        return __awaiter(this, void 0, void 0, function* () {
            this.worker.postMessage({
                type: 'init-output',
                sampleRate: sampleRate
            });
        });
    }
    uploadSong(playData) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(playData);
            this.worker.postMessage({
                type: 'upload-song',
                song: playData
            });
        });
    }
    prepareAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ready)
                return;
            yield this.prepareWorker();
            yield this.prepareAudio();
            this.ready = true;
        });
    }
    prepareWorker() {
        return __awaiter(this, void 0, void 0, function* () {
            this.worker = new Worker(new URL('./SF2Worker.js', import.meta.url));
            return new Promise((resolve) => {
                this.worker.onmessage = ((ev) => {
                    switch (ev.data.type) {
                        case 'finish-loading':
                            resolve();
                            break;
                    }
                });
            });
        });
    }
    prepareAudio() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.audioCtx !== null) {
                console.warn('audio context already exists');
                return;
            }
            const ctx = new AudioContext();
            this.audioCtx = ctx;
            yield ctx.audioWorklet.addModule(new URL('./SF2Worklet.js', import.meta.url));
            const node = new AudioWorkletNode(ctx, 'sf2-processor');
            const gain = new GainNode(ctx);
            gain.gain.value = 0.3;
            node.connect(gain);
            gain.connect(ctx.destination);
            let sample_rate = ctx.sampleRate;
            this.worker.postMessage({
                type: 'pass-port',
                port: node.port,
                sampleRate: sample_rate
            }, [node.port]);
        });
    }
    output(info) {
        if (!this.ready) {
            console.warn('not ready');
            return;
        }
        switch (info.entry.type) {
            case 'note-on':
                this.worker.postMessage({
                    type: 'note-on',
                    chan: info.chan,
                    key: info.entry.key,
                    vel: info.entry.velocity / 127.0
                });
                break;
            case 'note-off':
                this.worker.postMessage({
                    type: 'note-off',
                    chan: info.chan,
                    key: info.entry.key
                });
                break;
            default:
                console.warn('SF2Player output: unsupported entry: ' + info.entry.type);
        }
    }
    start() {
    }
    stop() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            console.log('closing SF2Player');
            (_a = this.worker) === null || _a === void 0 ? void 0 : _a.terminate();
            this.worker = null;
            yield ((_b = this.audioCtx) === null || _b === void 0 ? void 0 : _b.close());
            this.audioCtx = null;
            this.ready = false;
        });
    }
}
